import { afterNextRender, Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { HeaderComponent } from './shared/components/header/header.component';
import { CookieBanner } from "./shared/components/cookie-banner/cookie-banner";
import { CookieConsentService } from './shared/services/cookie-consent.service';
import { Footer } from './shared/components/footer/footer';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TranslateModule, HeaderComponent, CookieBanner, Footer],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private readonly translate = inject(TranslateService);
  private readonly cookieConsent = inject(CookieConsentService);

  protected readonly title = signal('frontend');

  constructor() {
    afterNextRender(() => {
      this.cookieConsent.init();
    });
  }

  switchLang(lang: string) {
    this.translate.use(lang);
  }
}
